'use strict';

var _classCallCheck = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userStatus = require('../constants/userStatus');

var _userStatus2 = _interopRequireDefault(_userStatus);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Usage:
 * const isUser = new IsUser(userType);
 * (isUser.investor || isUser.issuer) && renderSomething()
 */


var IsStatus =
/**
 * @param status - String
 */
function IsStatus(status) {
  _classCallCheck(this, IsStatus);

  this.NA = status === _userStatus2.default.NA, this.APPLIED = status === _userStatus2.default.APPLIED, this.REGISTERED = status === _userStatus2.default.REGISTERED, this.INVITED = status === _userStatus2.default.INVITED, this.CONFIRMED = status === _userStatus2.default.CONFIRMED, this.USER_DATA_FILLED = status === _userStatus2.default.USER_DATA_FILLED, this.CV_ADDED = status === _userStatus2.default.CV_ADDED, this.SIGNED = status === _userStatus2.default.SIGNED, this.KYC_PASSED = status === _userStatus2.default.KYC_PASSED, this.ACCOUNT_CREATED = status === _userStatus2.default.ACCOUNT_CREATED, this.KYC_DOCUMENT_ADDED = status === _userStatus2.default.KYC_DOCUMENT_ADDED, this.KYC_DOCUMENT_VALIDATED = status === _userStatus2.default.KYC_DOCUMENT_VALIDATED, this.PAYMENT_METHOD_ADDED = status === _userStatus2.default.PAYMENT_METHOD_ADDED, this.WAITING_FOR_WALLET_REPLENISHMENT = status === _userStatus2.default.WAITING_FOR_WALLET_REPLENISHMENT, this.WALLET_FILLED = status === _userStatus2.default.WALLET_FILLED, this.SUBSCRIPTION_BOUGHT = status === _userStatus2.default.SUBSCRIPTION_BOUGHT, this.COMPLIANCE_OFFICER_ADDED = status === _userStatus2.default.COMPLIANCE_OFFICER_ADDED;
};

exports.default = IsStatus;